import React from 'react';
import { Button } from 'semantic-ui-react';
import '../styles/ReportUpsell.scss';
import { LineBreak } from '../../components/LineBreak/Linebreak';
import { useAppSelector } from '../../hooks/ReduxHooks';
import { EditionCode } from '../../subscription/subscription-types';
import { useNavigate } from 'react-router-dom';
import { analyticsTrack } from '../../helpers/AnalyticsUtility';

const LEARN_MORE = 'Learn more';
const UPGRADE_TO_ADVANCED = 'Upgrade to Advanced';

export default function ReportUpsell() {
  const editionCode = useAppSelector<EditionCode>((state) => state.profile.client.subscription);
  const navigate = useNavigate();

  const trackReportUpsell = (btnType: string) => {
    analyticsTrack('Upsell Clicked', {
      Upsell: 'Reports',
      Button: btnType,
      CurrentTier: editionCode
    });
  };

  const onLearnMoreClick = () => {
    trackReportUpsell(LEARN_MORE);
    window.open('https://help.goformz.com/en/articles/3220030-reports-overview', '_blank');
  };

  const onUpgradeClick = () => {
    trackReportUpsell(UPGRADE_TO_ADVANCED);
    navigate('/billing?upgrade=gf-advanced');
  };

  return (
    <div className="upsell">
      <div className="upsell-title-row">
        <span className="upsell-title">What can you learn from your Form data? Find out with Reports.</span>
      </div>
      <div className="upsell-info-row">
        <div className="upsell-info-img-col">
          <div className="upsell-img"></div>
        </div>
        <div className="upsell-info-detail-col">
          <div className="upsell-info-detail-container">
            <span className="upsell-detail-title">Capture and leverage data from multiple Templates</span>
            <LineBreak height={10} />
            <span className="upsell-detail-subtext">
              Aggregate Form data from multiple Templates with Reports. Review your findings, and use them to take action.
            </span>
            <LineBreak height={40} />
            <div className="upsell-btn-container">
              <Button className="ui button" onClick={onLearnMoreClick}>
                {LEARN_MORE}
              </Button>
              <Button className="primary upsell-upgrade-btn" onClick={onUpgradeClick}>
                {UPGRADE_TO_ADVANCED}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
